<template>
  <div class="shop-picker-container">
    <div class="shop-picker-label" v-if="label">{{ label }}</div>
    <div class="flex flex-between mb10" v-if="!readonly">
      <div class="flex flex-center">
        <el-button
          type="primary"
          plain
          size="small"
          @click="openPickerDialog"
          >+ 选择门店
        </el-button>
         <el-checkbox :value="isAllShops" class="ml10" @change="handleAllShopsChange">全部门店</el-checkbox>
        <el-input
          v-model="localSearchKeyword"
          placeholder="请输入门店名称/关键词搜索"
          clearable
          size="small"
          style="width: 220px"
          class="ml10"
          @input="handleLocalSearch"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <el-button @click="downloadTemplate" type="primary" size="small"
          >导出模板
        </el-button>
        <el-button type="primary" size="small" class="upload-file-btn pointer"
          >导入表格
          <input
            type="file"
            class="pointer"
            @change="handleFileImport"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </el-button>
      </div>
    </div>
    
    <!-- 只读模式 -->
    <div class="flex flex-between mb10" v-if="readonly">
      <div class="flex flex-center">
        <el-input
          v-model="localSearchKeyword"
          placeholder="请输入门店名称/关键词搜索"
          clearable
          size="small"
          style="width: 220px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>

    <!-- 已选门店表格 -->
    <div class="table mb10">
      <el-table
        stripe
        ref="selectedShopTable"
        :data="displayedSelectedShops"
        style="width: 100%"
        size="small"
        border
        max-height="400"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店名称"
          min-width="150"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="shopId"
          label="门店编码"
          min-width="120"
        ></el-table-column> -->
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
          v-if="!readonly"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" content="删除" placement="top">
              <div class="pointer" @click="removeShop(scope.row)">
                <span class="hmicon icon-shanchu primary"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="hm-pagination" v-if="displayedSelectedShopsTotal > 0">
      <el-pagination
        background
        :total="displayedSelectedShopsTotal"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
      ></el-pagination>
    </div>

    <!-- 导入失败弹窗 -->
    <el-dialog
      :visible.sync="showImportError"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
      title="导入失败"
    >
      <div slot="title">
        <span class="dialog-title">导入失败</span>
        <span class="ml10" style="color: red; font-size: 14px">门店编码有误、门店不存在都会导致导入失败</span>
      </div>
      <div class="mt10" style="font-size: 14px" v-if="importErrorList.length">
        您有<span style="color: red">{{ importErrorList.length }}</span>条数据导入失败！
      </div>
      <div class="mt10" v-if="importSuccessCount > 0">
        您有<span style="color: #67C23A">{{ importSuccessCount }}</span>条数据导入成功！
      </div>
      <div class="mb20" style="float: right">
        <span class="pointer ml10 blue-text" @click="exportErrorData">导出失败数据</span>
      </div>
      <div class="mt20">
        <el-table :data="importErrorList" border size="small">
          <el-table-column prop="shopName" header-align="center" align="center" label="门店名称" min-width="150"></el-table-column>
          <el-table-column prop="shopId" header-align="center" align="center" label="门店编码" min-width="120"></el-table-column>
          <el-table-column prop="errorMsg" header-align="center" align="center" label="失败原因" min-width="200"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 选择门店弹窗 -->
    <shop-picker-dialog
      :visible.sync="pickerDialogVisible"
      :shop-list="availableShops"
      :selected-ids="selectedShopIds"
      @confirm="onDialogConfirm"
    />
  </div>
</template>

<script>
import ShopPickerDialog from './ShopPickerDialog.vue';
import * as XLSX from "xlsx/xlsx";

export default {
  name: 'ShopPicker',
  components: {
    ShopPickerDialog
  },
  props: {
    label: {
      type: String,
      default: '选择门店：'
    },
    availableShops: {
      type: Array,
      default: () => []
    },
    selectedShops: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      pickerDialogVisible: false,
      localSearchKeyword: '',
      showImportError: false,
      importErrorList: [],
      importSuccessCount: 0
    };
  },
  computed: {
    // 选中的门店ID列表
    selectedShopIds() {
      return this.selectedShops.map(shop => shop.shopId || shop.id);
    },
    // 过滤后的已选门店
    filteredSelectedShops() {
      let list = [...this.selectedShops];
      
      // 过滤掉 shopId 为 "直营店" 和 "加盟店" 的数据
      list = list.filter(item => {
        const shopId = item.shopId || item.id;
        return shopId !== '直营店' && shopId !== '加盟店';
      });
      
      if (this.localSearchKeyword) {
        const keyword = this.localSearchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameMatch = (item.shopName || item.name || '').toLowerCase().includes(keyword);
          const codeMatch = (item.shopId || item.id || '').toLowerCase().includes(keyword);
          return nameMatch || codeMatch;
        });
      }
      return list;
    },
    // 分页显示的已选门店
    displayedSelectedShops() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredSelectedShops.slice(start, end);
    },
    // 过滤后的总数
    displayedSelectedShopsTotal() {
      return this.filteredSelectedShops.length;
    },
    // 是否全选（排除直营店和加盟店后）
    isAllShops() {
      const validShops = this.availableShops.filter(shop => {
        const shopId = shop.shopId || shop.id;
        return shopId !== '直营店' && shopId !== '加盟店';
      });
      return this.selectedShops.length === validShops.length && validShops.length > 0;
    }
  },
  methods: {
    // 打开选择弹窗
    openPickerDialog() {
      this.pickerDialogVisible = true;
    },
    // 本地搜索
    handleLocalSearch() {
      this.currentPage = 1;
    },
    // 全部门店切换
    handleAllShopsChange(val) {
      if (val) {
        // 选中所有门店（排除直营店和加盟店）
        const allShops = this.availableShops.filter(shop => {
          const shopId = shop.shopId || shop.id;
          return shopId !== '直营店' && shopId !== '加盟店';
        });
        this.$emit('update:selectedShops', allShops);
        this.$emit('change', allShops);
      } else {
        // 清空选择
        this.$emit('update:selectedShops', []);
        this.$emit('change', []);
      }
    },
    // 下载模板
    downloadTemplate() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["门店名称", "门店编码"];
        const data = [];
        exportJsonToExcel(tHeader, data, "门店导入模板");
      });
    },
    // 文件导入
    handleFileImport(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        
        let jsonData = [];
        workbook.SheetNames.forEach((sheetName) => {
          const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
          if (roa.length) {
            jsonData = roa.slice(1); // 去掉表头
          }
        });

        this.processImportData(jsonData);
        event.target.value = '';
      };
      reader.readAsBinaryString(file);
    },
    // 处理导入数据
    async processImportData(data) {
      const importList = [];
      let hasEmpty = false;

      data.forEach((row) => {
        if (!row[0] && !row[1]) return;
        if (!row[0] || !row[1]) {
          hasEmpty = true;
        } else {
          importList.push({
            shopName: row[0],
            shopId: String(row[1]).replace(/\s*/g, "")
          });
        }
      });

      if (hasEmpty) {
        this.$message.warning('导入失败，请导入完整门店信息！');
        return;
      }

      if (importList.length === 0) {
        this.$message.warning('请先上传有效的文件');
        return;
      }

      // 调用导入验证
      await this.validateImportShops(importList);
    },
    // 验证导入的门店
    async validateImportShops(importList) {
      try {
        const shopCodes = importList.map(v => ({ shopCode: v.shopId }));
        const result = await this.$store.dispatch("importFilterShopCodeList", shopCodes);
        
        if (result && result.result) {
          const successList = result.result.successShopInfoModelList || [];
          const failList = result.result.failShopInfoModelList || [];
          
          this.importSuccessCount = successList.length;

          // 合并已选门店
          if (successList.length > 0) {
            const currentShops = this.selectedShops.filter(s => s.shopId !== 'all' && s.id !== 'all');
            const newShops = successList.map(shop => ({
              shopId: shop.shopId,
              shopName: shop.shopName,
              ...shop
            }));
            
            // 去重
            const shopMap = new Map();
            [...currentShops, ...newShops].forEach(shop => {
              const id = shop.shopId || shop.id;
              if (!shopMap.has(id)) {
                shopMap.set(id, shop);
              }
            });
            
            const mergedShops = Array.from(shopMap.values());
            this.$emit('update:selectedShops', mergedShops);
            this.$emit('change', mergedShops);
          }

          // 处理失败数据
          if (failList.length > 0) {
            this.importErrorList = failList.map(item => ({
              shopName: item.shopName || '',
              shopId: item.shopId || item.shopCode || '',
              errorMsg: item.result || '门店不存在或编码错误'
            }));
            this.showImportError = true;
          } else {
            this.importErrorList = [];
          }

          if (successList.length > 0 && failList.length === 0) {
            this.$message.success(`成功导入 ${successList.length} 家门店`);
          }
        } else {
          this.$message.error((result && result.errMsg) || '导入失败，请稍后重试');
        }
      } catch (error) {
        console.error('导入门店失败:', error);
        this.$message.error('导入门店失败，请稍后重试');
      }
    },
    // 删除门店
    removeShop(shop) {
      const shopId = shop.shopId || shop.id;
      const newList = this.selectedShops.filter(s => (s.shopId || s.id) !== shopId);
      this.$emit('update:selectedShops', newList);
      this.$emit('change', newList);
      this.$emit('remove', shop);
    },
    // 分页变化
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    // 弹窗确认
    onDialogConfirm(selectedShops) {
      this.$emit('update:selectedShops', selectedShops);
      this.$emit('change', selectedShops);
      this.pickerDialogVisible = false;
    },
    // 导出错误数据
    exportErrorData() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["门店名称", "门店编码", "失败原因"];
        const data = this.importErrorList.map(item => [item.shopName, item.shopId, item.errorMsg]);
        exportJsonToExcel(tHeader, data, "门店导入失败数据");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.shop-picker-container {
  width: 60%;
  .shop-picker-label {
    color: #666;
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.hm-pagination {
  font-family: PingFang SC;
  margin-top: 20px;
}

.pointer {
  cursor: pointer;
}

.primary {
  color: #0B66EA;
}

.mr10 {
  margin-right: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.ml10 {
  margin-left: 10px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mb20 {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.flex-between {
  justify-content: space-between;
}

.flex-center {
  align-items: center;
}

.upload-file-btn {
  position: relative;
  overflow: hidden;
  display: inline-block;
  
  input {
    position: absolute;
    left: 0px;
    top: 0px;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.blue-text {
  color: #0B66EA;
}
</style>
